export default function (state = {}, action) {
   switch (action.type) {

      case 'GET_ATT_STATUS':
         {
            return {
               ...state,
               attStatusPayload: action.payload
            };
         }
      case 'FIND_ASSET':
         {
            return {
               ...state,
               findAssetPayload: action.payload
            };
         }
      default:
         return state;
   }
}

